'use strict';

import EditAddressController from 'common/popup.component/EditAddressController';

require('npm/odometer/themes/odometer-theme-default.css');

const ALL_PACKED = 'allPacked';
const POPULAR = 'popular';
const CUSTOM = 'custom';

class QuotesController {
    /*@ngInject*/
    constructor ($mdDialog, $stateParams, $state, orderStore, utils, inventory, $timeout, $scope, $q) {
        "ngInject";
        _.extend(this, {
            name: 'quotes',
            $stateParams: $stateParams,
            $state: $state,
            $mdDialog: $mdDialog,
            $timeout: $timeout,
            orderStore: orderStore,
            utils: utils,
            inventory: inventory,
            $q: $q,
            $scope: $scope
        });

        this.getChart = this.getChartConstructor();
        this.getOdometer = this.getOdometerConstructor();

        this.showChartHelpText = true;
        this.showPackingHelpText = true;

        this.orderLoader = this.initialize();

        $scope.$watch(
            () => this.order && this.order.order_time,
            (updatedMoveDateInSeconds) => this.selectQuoteForDate(updatedMoveDateInSeconds)
        );

    }

    initialize() {
        return this.orderStore.getOrderWithQuoteWithRedirectionCheck(this.$stateParams.orderId)
            .then(
                (orderWithQuote) => {
                    this.order = orderWithQuote.order;
                    this.orderQuote = orderWithQuote.quote;

                    this.orderQuote.surges = _.map(this.orderQuote.surges, function(surge) {
                        if(surge.time_slot_1 === 0.0001) {
                            surge.time_slot_1 = 0;
                        }
                        if(surge.time_slot_2 === 0.0001) {
                            surge.time_slot_2 = 0;
                        }
                        if(surge.time_slot_3 === 0.0001) {
                            surge.time_slot_3 = 0;
                        }
                        if(surge.time_slot_4 === 0.0001) {
                            surge.time_slot_4 = 0;
                        }
                        return surge;
                    });

                    // Adding default values for now
                    _.extend(this.orderQuote, {
                        delivery_time: '6 - 8 days'
                    });

                    if (!this.order.time_slot) {
                        this.order.time_slot = 'time_slot_1';
                    }

                    // If an existing preference is found, use the custom tab
                    const packingPreferenceFromOrder = this.order.user_preference ? 2 : 1;
                    this.majorPackingPreference = packingPreferenceFromOrder;
                    this.timeSlots = this.orderStore.timeSlots;

                    if(this.order.total_cubic_feet > 150) {
                        this.timeSlots.splice(1,1); // remove 2nd time slot (10am - 12pm)
                    }
                    if((this.order.from_address.name.indexOf('Bengaluru') != -1) && (this.order.to_address.name.indexOf('Bengaluru') != -1)) {
                        if(this.order.total_cubic_feet < 350) {
                            this.timeSlots.splice(0,1); // remove 1st  time slot (8am - 10am)
                        }
                    }

                    this.timeSlotIndex = _.indexBy(this.timeSlots, 'value');

                    this.flatOrderItems = this.utils.flattenOrderItems(this.order.order_items, this.order.item_stats, this.order.vehicle_statistics, this.order.property_type);
                    this.itemColumns = this.getItemColumnsFromInventory(this.flatOrderItems, this.order.item_stats, this.getDepreciationFactor(this.flatOrderItems, this.order.property_type));

                    /*
                    * if no user preference is given then this the first time the use is seeing the quote so we load the popular preference
                    * in other cases the packign status along with each item of the order is loaded through binding
                    * */
                    if(!this.order.user_preference) {
                        this.packItemsBy(POPULAR, this.order.item_stats);
                    } else {
                        this.packItemsBy(CUSTOM, this.order.item_stats);
                    }

                    this.quotePrices = this.populateQuotePrices(this.orderQuote, this.flatOrderItems, this.order.item_stats, this.order.property_type, this.order.time_slot, this.order);

                    this.selectQuoteForDate(this.order.order_time);
                    this.createChart(this.getChart())
                        .then((chart) => {
                            this.chart = chart;
                            this.$timeout(() => {
                                this.doNotUseDefaultPackingSettings = false;
                            });
                        });

                    this.setupOdometer(this.getOdometer())
                        .then((odometer) => {
                            this.odometer = odometer;
                        });
                },
                (error) => this.$q.reject(error)
            )
    }

    getItemColumnsFromInventory (inventory, itemStatistics, damageCoverValuationRatio) {
        const packableItems = _.indexBy(itemStatistics, 'id');
        let itemsInInventory = _(inventory)
            .map(item => this.utils.withDescriptionOf(item, 6))
            .map(item => _.extend(item, {
                isPackable: (packableItems[item.item_statistic_id] || {}).candidate_for_packing,
                requiresPacking: (packableItems[item.item_statistic_id] || {}).candidate_for_economy
            }))
            .groupBy(item => item.qualifiedName)
            // Update item valuation factoring in damage cover factor
            .map((items, category) => {
                const itemToCloneAsCategory = items[0];
                return _.extend({}, itemToCloneAsCategory, {
                    isPackable: (packableItems[itemToCloneAsCategory.item_statistic_id] || {}).candidate_for_packing,
                    requiresPacking: (packableItems[itemToCloneAsCategory.item_statistic_id] || {}).candidate_for_economy,
                    children: items,
                    quantity: items.length,
                    package_status: itemToCloneAsCategory.package_status
                })
            })
            .value();

        return _(itemsInInventory)
            .sortBy(item => item.score)
            .groupBy(item => this.utils.getRootNameOf(item, 2))
            .map((children, categoryName) => this.utils.withDescriptionOf({
                qualifiedName: categoryName,
                children: children
            }, 2))
            .sortBy(item => item.score)
            .map(category => {
                category.counts = {};
                category.counts[category.qualifiedName] = {size: _.sum(category.children, 'quantity')};
                category.isPackable = _.reduce(category.children, (result, item) => {
                    return result || (typeof item.isPackable == "undefined" ? false : item.isPackable)
                }, false);
                category.requiresPacking = _.every(category.children, { requiresPacking: true });
                category.package_status = _.every(category.children, { package_status: true });
                return category;
            })
            .groupBy(item => this.utils.getRootNameOf(item, 1))
            .map((children, categoryName) => this.utils.withDescriptionOf({
                qualifiedName: categoryName,
                children: children
            }, 1))
            .sortBy(category => this.utils.sortMajorCategories(category))
            .value();
    }

    /*ODOMETER*/
    getOdometerConstructor() {
        let Odometer = require('odometer');
        return () => {
            return Odometer;
        }
    }
    /*odometer setup*/
    setupOdometer(Odometer) {
        let deferred = this.$q.defer();

        this.$timeout(() => {
            let odometerElement = document.querySelector("[pk-component-id='client-quote-value-big']");
            if(window.innerWidth < 600){
                odometerElement = document.querySelector("[pk-component-id='client-quote-value-small']");
            }

            let odometer = new Odometer({
                el: odometerElement,
                value: _.ceil(this.order.client_quote_value, 0),
                duration: 200,
                format: '(,ddd)',
                theme: 'default'
            });
            deferred.resolve(odometer);
        });
        return deferred.promise;
    }

    updateOdometer() {
        if (!this.odometer) {
            return false;
        }

        this.$timeout(() => {
            this.odometer.update(_.ceil(this.order.client_quote_value, 0));
        });
    }

    /* CHART JS */
    getChartConstructor() {
        let Chart = require('chart.js');
        return () => {
            return Chart;
        }
    }

    createChart (Chart) {
        /*extending bar chart to dynamically set bar value spacing*/
        Chart.types.Bar.extend({
            name: "BarAlt",
            draw: function(){
                this.options.barValueSpacing = this.chart.width / 300;
                Chart.types.Bar.prototype.draw.apply(this, arguments);
            }
        });

        let deferred = this.$q.defer();

        let quoteType = this.quotePrices[this.majorPackingPreference];

        const selectedDateKey = this.getSelectedDateKey(this.order.order_time),
            selectedDateIndex = this.getSelectedDateIndex(selectedDateKey, quoteType.labels);

        let maxSurge = 0;
        this.orderQuote.surges.forEach( (surge) => {
            maxSurge = _.max([surge.time_slot_1, surge.time_slot_2, surge.time_slot_3, surge.time_slot_4, maxSurge]);
        });

        let MaxQuotePrice = this.getQuotePriceFor(this.orderQuote, maxSurge, ALL_PACKED, this.flatOrderItems, this.order.item_stats, this.order.property_type);

        const baseColor = '#b4e1fd',
            selectedColor = '#439fd9',
            highlightColor = '#439fd9',
            scaleSteps = 2,
            scaleStepWidth = _.ceil(MaxQuotePrice/2*1.1, -2);

        let chartData = {
            labels : quoteType.labels,
            datasets : [
                {
                    fillColor: baseColor,
                    highlightFill: highlightColor,
                    data : quoteType.prices
                }
            ]
        };

        /* timeout required to wait for creation of canvas element */
        this.$timeout(() => {
            let chartElementId = quoteType.name + "-bar-chart-big";

            if(window.innerWidth < 600) {
                chartElementId = quoteType.name + "-bar-chart-small";
            }

            let chartElement = document.querySelector("[pk-component-id='"+ chartElementId +"']"),
                chartElement2dCanvasContext = chartElement.getContext('2d');

            let chart = new Chart(chartElement2dCanvasContext).BarAlt(chartData, {
                responsive: true,
                scaleOverride: true,
                scaleLabel: (valueObject) => {
                    return this.utils.monetize(valueObject.value);
                },
                scaleSteps: scaleSteps,
                scaleStepWidth: scaleStepWidth,
                scaleStartValue: 0,
                scaleShowVerticalLines: false,
                showTooltips: true,
                tooltipFillColor: '#142f41',
                tooltipFontColor: '#ffffff',
                tooltipFontStyle: 'normal',
                tooltipTemplate: (valueObj) => {
                    return  valueObj.label + ' - ' + this.utils.monetize(valueObj.value);
                },
                tooltipCaretSize: 8,
                tooltipCornerRadius: 0,
                tooltipYPadding: 5,
                tooltipXPadding: 5
            });

            this.colorBarWith(selectedColor, highlightColor,chart.datasets[0].bars[selectedDateIndex]);

            chartElement.onclick = (evt) => {
                this.showChartHelpText = false;
                let selectedBar = chart.getBarsAtEvent(evt)[0];
                if(selectedBar) {
                    _.forEach(chart.datasets[0].bars, (bar) => this.colorBarWith(baseColor, highlightColor, bar));
                    this.colorBarWith(selectedColor, highlightColor, selectedBar);

                    this.$scope.$apply(() => {
                        quoteType.onSelectQuote(selectedBar.label);
                        chart.update();
                        this.updateOdometer();
                    });
                }
            };

            chart.updateBars = (values) => {
                _.forEach(chart.datasets[0].bars, (bar, index) => bar.value = values[index]);
                chart.update();
            };

            deferred.resolve(chart);
        });

        return deferred.promise;
    }

    colorBarWith(fillColor, highlightColor,context) {
        context._saved.fillColor = fillColor;
        context._saved.highlightFill = highlightColor;
        context.fillColor = fillColor;
        context.highlightFill = highlightColor;
    }

    redrawChart() {
        if(this.chart) {
            this.chart.destroy();
        }

        this.createChart(this.getChart())
            .then((chart) => {
                this.chart = chart;
                this.selectQuoteForDate(this.order.order_time);
            });
    }

    tabChange (majorPackingType, itemStatistics) {
        const stats = itemStatistics || (this.order && this.order.item_stats);
        if (_.isUndefined(stats)) {
            return false;
        }

        this.packItemsBy(majorPackingType, stats);
        this.order.user_preference = majorPackingType;

        // This is a hacky flag to let us know that this event was triggered
        // by a click on the tab heading and not by changing a packing setting
        if (!this.doNotUseDefaultPackingSettings) {
            this.updateAllQuotePrices({update: false});
        }

        this.redrawChart();
        this.updateOdometer();
    }

    populateQuotePrices (quote, orderItems, itemStatistics, propertyType, timeSlot, order) {
        const labels = {allPacked: 'All items Packed', popular: 'Popular', custom: 'Custom'};
        return _.map([ALL_PACKED, POPULAR, CUSTOM], (packingPreference, index) =>
            _.extend(this.calculateQuotePriceFor(quote, packingPreference, orderItems, itemStatistics, propertyType, timeSlot), {
                name: packingPreference,
                displayName: labels[packingPreference],
                deliveryTime: quote.delivery_time,
                onSelectQuote: this.onQuoteSelect(index, order)
            })
        );
    }

    calculateQuotePriceFor (quote, quoteType, orderItems, itemStatistics, propertyType, timeSlot) {
        const surges = quote.surges;
        const quotesDates = _(surges)
            .pluck('surge_date')
            .map((dateString) => moment(dateString))
            .value();
        const labelFormat = 'DD MMM';

        return {
            labels: _.map(quotesDates, (date) => date.format(labelFormat)),
            dates: quotesDates,
            prices: _.map(quotesDates, (date, index) => this.getQuotePriceFor(quote, surges[index][timeSlot], quoteType, orderItems, itemStatistics, propertyType))
        }
    }

    getQuotePriceFor (quote, surge, quoteType, orderItems, itemStatistics, propertyType) {
        const packableItems = _.indexBy(itemStatistics, 'id');
        const quoteParameters = this.flattenQuoteParams(quote);

        const specialHandlingCharges = quote.special_handling_charges ? quote.special_handling_charges : 0;

        let packedItems = [];
        switch (quoteType) {
            case ALL_PACKED:
                packedItems = _.filter(orderItems, (item) => item.isPackable);
                break;
            case POPULAR:
                packedItems = _.filter(orderItems, (item) => {
                    let itemStats = packableItems[item.item_statistic_id];
                    return item.isPackable && itemStats && itemStats.candidate_for_economy;
                });
                break;
            case CUSTOM:
                packedItems = _.filter(orderItems, (item) => {
                    return item.isPackable && (item.requiresPacking || item.package_status);
                });
                break;
        }

        const packingMaterialCost = _.sum(packedItems, (item) => {
            let itemStats = packableItems[item.item_statistic_id] || {},
                itemQty = item.quantity;
            return (itemQty * itemStats.packing_cost) || 0;
        });

        const packingTimeInMinutes = _.sum(packedItems, (item) => {
            let itemStats = packableItems[item.item_statistic_id] || {},
                itemQty = item.quantity;
            return (itemQty * itemStats.packing_time) || 0;
        });

        const packingTimeInHours = packingTimeInMinutes / 60;

        const packingCost = packingMaterialCost
            + (packingTimeInHours * quoteParameters.labor_rate_source)
            + (packingTimeInHours * quoteParameters.truck_holding_rate_source) / quoteParameters.no_of_labours;

        const surgeFactor = surge || 0;
        if (surgeFactor === 0) {
            return 0;
        }

        const damageCover = 0;

        return surgeFactor
            * (quoteParameters.transportation_cost_source + packingCost + quoteParameters.labour_cost_source)
            + quoteParameters.labour_cost_destination
            + damageCover
            + specialHandlingCharges;
    }

    getSurgeForDateAndTimeSlot(quote, orderTimeInSeconds, timeSlot) {
        const surges = quote.surges;
        const labelFormat = 'DD MMM';
        const indexedSurges = _.indexBy(surges, (surge) => moment(surge.surge_date).format(labelFormat));

        const formattedOrderTime = moment(orderTimeInSeconds * 1000).format(labelFormat);

        const surgeOnDate = indexedSurges[formattedOrderTime];

        return surgeOnDate ? surgeOnDate[timeSlot] : 1;
    }

    flattenQuoteParams (quote) {
        return _.extend({},
            this.utils.pluckAll(quote, ['labor_rate_source', 'truck_holding_rate_source']),
            _.reduce(quote.quote, (accumalator, params) => _.extend(accumalator, params), {})
        );
    }

    getDamageCoverFor (orderItems) {
        const actualValuation = _.sum(orderItems, (item) => item.quantity * item.valuation);
        const damageCoverFactor = 0.035;

        return actualValuation * damageCoverFactor;
    }

    getDepreciationFactor (orderItems, propertyType) {
        const defaultValuation = this.utils.defaultValuationOf(propertyType);
        const actualValuation = _.sum(orderItems, (item) => item.quantity * item.valuation);
        return defaultValuation / actualValuation;
    }

    packItemsBy (majorPackingType, itemStatistics) {
        const packableItems = _.indexBy(itemStatistics, 'id');

        // This is a hack to prevent overriding existing packing preferences
        // For example, altering packing preference for a single item 
        //  when in the 'All Packed' tab, should not reset settings for any other item.
        if (this.doNotUseDefaultPackingSettings) {
            return null;
        }

        let itemsInInventory = _(this.itemColumns)
            .pluck('children')
            .flatten()
            .pluck('children')
            .flatten()
            .pluck('children')
            .flatten()
            .value();

        let itemGroups = _(this.itemColumns)
            .pluck('children')
            .flatten()
            .pluck('children')
            .flatten()
            .value();

        let rootCategories = _(this.itemColumns)
            .pluck('children')
            .flatten()
            .value();

        switch (majorPackingType) {
            case ALL_PACKED:
                _.forEach(itemsInInventory, (item) => {
                    item.package_status = item.isPackable;
                });
                _.forEach(itemGroups, (itemGroup) => {
                    itemGroup.package_status = _.reduce(itemGroup.children, (result, itemGroup) =>  {
                        return result && (itemGroup.isPackable ? itemGroup.package_status : true);
                    }, true);
                });
                _.forEach(rootCategories, (category) => {
                    category.package_status = _.every(category.children, {package_status: true});
                });

                break;
            case POPULAR:
                _.forEach(itemsInInventory, (item) => {
                    item.package_status = item.isPackable && item.requiresPacking;
                });
                _.forEach(itemGroups, (itemGroup) => {
                    itemGroup.package_status = _.every(itemGroup.children, {package_status: true});
                });
                _.forEach(rootCategories, (category) => {
                    category.package_status = _.every(category.children, {package_status: true});
                });
                break;
            case CUSTOM:
                _.forEach(itemsInInventory, (item) => {
                    if(item.isPackable && item.requiresPacking) {
                        item.package_status =  true;
                    }
                });
                _.forEach(itemGroups, (itemGroup) => {
                    itemGroup.package_status = _.every(itemGroup.children, {package_status: true});
                });
                _.forEach(rootCategories, (category) => {
                    category.package_status = _.every(category.children, {package_status: true});
                });
                break;
        }
    }

    onQuoteSelect (packingPreferenceIndex, order) {
        return (quoteDateLabel) => {
            [order.order_time, order.client_quote_value] = this.getMoveDateAndPrice(quoteDateLabel, this.quotePrices[packingPreferenceIndex]);
        }
    }

    getMoveDateAndPrice (key, quoteType) {
        let indexOfPriceInList = this.getSelectedDateIndex(key, quoteType.labels),
            quotePrice = quoteType.prices[indexOfPriceInList],
            quoteDate = quoteType.dates[indexOfPriceInList];

        // Order time is stored as seconds
        const moveDateInSeconds = parseInt(quoteDate.toDate().getTime() / 1000, 10);

        return [moveDateInSeconds, quotePrice];
    }

    changeAddress (evt) {
        this.$mdDialog.show({
                controller: EditAddressController,
                controllerAs: 'address',
                template: require('common/popup.component/EditAddress.popup.html'),
                locals: {
                    order: this.getUpdatedOrder(this.orderStore.status.QUOTED)
                },
                parent: angular.element(document.body),
                targetEvent: evt,
                clickOutsideToClose: true
            })
            .then((dialog) => {
                let deferred = this.orderStore.saveOrder(dialog.order)
                    .then(
                        () => this.orderLoader = this.initialize(),
                        (error) => this.$q.reject()
                    );
                this.orderLoader = deferred;
                return deferred;
            });
    }

    onPackingStateChanged (evt) {
        let action = evt.action,
            subCategory = evt.subCategory,
            itemGroup = evt.itemGroup,
            item = evt.item;

        switch (action) {
            case 'subCategoryPackingState':
                _.forEach(subCategory.children, (itemGroup) => {
                    itemGroup.package_status = itemGroup.requiresPacking || (itemGroup.isPackable && subCategory.package_status);
                    _.forEach(itemGroup.children, (item) => {
                        item.package_status = item.isPackable && itemGroup.package_status;
                    });
                });
                break;
            case 'itemGroupPackingState':
                /**
                 * Pack/Unpack all items in this group
                 */
                _.forEach(itemGroup.children, (item) => {
                    item.package_status = item.isPackable && itemGroup.package_status;
                });

                let allItemsInSubCategoryPacked = _.reduce(subCategory.children, (result, itemGroup) =>  {
                    return result && (itemGroup.isPackable ? itemGroup.package_status : true);
                }, true);
                subCategory.package_status = allItemsInSubCategoryPacked;
                break;
        }

        this.updateAllQuotePrices();
        this.activateTab({name: CUSTOM});
        
    }

    updateAllQuotePrices (options) {
        let selectedDateKey = this.getSelectedDateKey(this.order.order_time);

        _.forEach([ALL_PACKED, POPULAR, CUSTOM], (packingPreference, index) => {
            let prices = this.calculateQuotePriceFor(this.orderQuote, packingPreference, this.flatOrderItems, this.order.item_stats, this.order.property_type, this.order.time_slot);
            this.quotePrices[index].prices = prices.prices;
        });

        /*Set current order price*/
        this.quotePrices[this.majorPackingPreference].onSelectQuote(selectedDateKey);

        const updateChart = (options ? options.update : true) && this.chart && this.chart.update;
        if (updateChart) {
            const activeQuotePrices = this.quotePrices[this.majorPackingPreference].prices;
            this.chart.updateBars(activeQuotePrices);
        }

        this.updateOdometer();
        this.$timeout(() => this.selectQuoteForDate(this.order.order_time));
    }

    activateTab (withName) {
        let tabIndex = _.findIndex(this.quotePrices, withName);
        let selectedDateKey = this.getSelectedDateKey(this.order.order_time);
        this.majorPackingPreference = tabIndex;
        this.quotePrices[this.majorPackingPreference].onSelectQuote(selectedDateKey);
        this.doNotUseDefaultPackingSettings = true;
        this.$timeout(() => this.doNotUseDefaultPackingSettings = false);
    }

    goToLocation () {

        //conditions check
        this.conditionsCheck(() => {
            this.orderLoader = this.orderStore.saveOrder(this.getUpdatedOrder(this.orderStore.status.CONFIRMED))
                .then(
                    (order) => {
                        let nextState = this.utils.getAdminStateIfApplicable('base.location');
                        this.$state.go(nextState, {orderId: order.id});
                    }
                );
        });

    }

    editInventory() {
        let order = this.getUpdatedOrder(this.orderStore.status.QUOTED);
        delete order.surge_factor;
        delete order.pay_later;
        delete order.client_quote_value;
        this.orderLoader = this.orderStore.saveOrder(order)
            .then(
                (order) => {
                    let nextState = this.utils.getAdminStateIfApplicable('base.home');
                    this.$state.go(nextState, {orderId: order.id});
                }
            );
    }

    getUpdatedOrder(orderStatus) {
        let updatedInventoryItems = _(this.itemColumns)
            .pluck('children')
            .flatten()
            .pluck('children')
            .flatten()
            .pluck('children')
            .flatten()
            .value();
        let mergedInventoryItems = this.utils.mergeOrderItems(updatedInventoryItems);

        let order = _.cloneDeep(this.order);
        order.order_items = mergedInventoryItems;
        order.order_time = parseInt(new Date(order.order_time * 1000).getTime() / 1000, 10);
        order.surge_factor = this.getSurgeForDateAndTimeSlot(this.orderQuote, order.order_time, order.time_slot)

        /**
         * Update the status as confirmed / finalized to ensure that
         *  a bill is generated for this order.
         */
        order.status = orderStatus;

        return order;
    }

    getSelectedDateIndex (key, dateLabels) {
        return _.findIndex(dateLabels, (dateLabel) => dateLabel === key);
    }

    getSelectedDateKey (moveDateInSeconds) {
        return moment(moveDateInSeconds * 1000).format('DD MMM');
    }

    getPackingPreference (packingPreferenceIndex) {
        return packingPreferenceIndex === 0
            ? ALL_PACKED
            : packingPreferenceIndex === 1
            ? POPULAR : CUSTOM;
    }

    standardizeDateFormat (moveDateInSeconds) {
        const moveDate = moment(moveDateInSeconds * 1000);
        return {
            date: moveDate.format('DD'),
            day: moveDate.format('dddd'),
            month: moveDate.format('MMMM'),
            year: moveDate.format('YYYY')
        };
    }

    selectQuoteForDate (moveDateInSeconds) {
        if (!moveDateInSeconds) {
            return false;
        }

        const key = this.getSelectedDateKey(moveDateInSeconds);
        this.selectedQuoteDate = this.standardizeDateFormat(moveDateInSeconds);
        [this.order.order_time, this.order.client_quote_value] = this.getMoveDateAndPrice(key, this.quotePrices[this.majorPackingPreference]);
    }

    noPackingPopup(callback) {

        var popupController = ($scope, $mdDialog) => {
            $scope.yes = () => {
                this.tabChange(POPULAR);
                this.activateTab({name: POPULAR});
                $mdDialog.hide();
            }
            $scope.no = () => {
                $mdDialog.hide();
                callback();
            }
        }

        this.$mdDialog.show({
            controller: popupController,
            template: require('common/popup.component/nopacking.popup.html'),
            parent: angular.element(document.body),
            clickOutsideToClose: true
        });

        popupController.$inject = ['$scope', '$mdDialog']; //to enable proper dependency injection during js minification

    }

    conditionsCheck(callback) {

        //packed item count
        let packedItemCount =_(this.itemColumns)
            .pluck('children')
            .flatten()
            .map((subCategory) => {
                if(!subCategory.disabled && subCategory.package_status) {
                    return true;
                }  else {
                    return false
                }
            })
            .pull(false)
            .value()
            .length;
          callback();


    }

    /* lodash ceil function for use in html */
    ceil(number, percision) {
        return _.ceil(number, percision);
    }

}

export default QuotesController;


// WEBPACK FOOTER //
// ./client/app/components/quotes/quotes.controller.js